import { legacyRedirect } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/snippets/new')({
  beforeLoad: legacyRedirect('/workspaces/:workspaceId/snippets/new'),
});
